import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import styles from './AttachedImages.module.scss';
import { Icon } from 'antd';
import { Lightbox } from '../../../../../modal_image';
import { createURL } from './utils/createURL';

const AttachedImages = ({ attachedImages, deleteAttachedImage }) => {
  const showPreviewRef = useRef();
  const [showPreview, setShowPreview] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (showPreviewRef.current && showPreview) {
      showPreviewRef.current.focus();
    }
  }, [showPreview, showPreview]);

  const clickImage = (currentImage) => {
    setShowPreview(true);
    setCurrentImageIndex(currentImage);
  };

  const handleClosePreview = () => {
    setShowPreview(false);
  };

  const handleNextPreview = () => {
    if (currentImageIndex + 1 < attachedImages.length) {
      setCurrentImageIndex(currentImageIndex + 1);
    } else {
      setCurrentImageIndex(0);
    }
  };

  const handlePrevPreview = () => {
    if (currentImageIndex - 1 >= 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    } else {
      setCurrentImageIndex(attachedImages.length - 1);
    }
  };

  const handleKeyDown = (e) => {
    console.log(e)
    if (attachedImages.length > 1) {
      if (e.key === 'ArrowRight') {
        handleNextPreview();
      }
      if (e.key === 'ArrowLeft') {
        handlePrevPreview();
      }
    }
  };

  const createImagePreview = useCallback((image) => {
    if (image instanceof File) {
      return createURL(image);
    } else {
      const data = Buffer.from(image.file, 'base64');
      return window.URL.createObjectURL(new Blob([data]));
    }
  }, []);

  return (
    <>
      {attachedImages.length ? (
        <div className={styles.attachedImages}>
          {attachedImages.map((image, index) => {
            const imagePreview = createImagePreview(image);

            return (
              <div className={styles.attachedFile} key={`image-file-${index}`}>
                <img
                  src={imagePreview}
                  alt={'img'}
                  className={styles.attachedImagePreview}
                  onClick={() => clickImage(index)}
                />
                <div
                  className={styles.deleteAttachedFile}
                  onClick={() => deleteAttachedImage(index)}
                >
                  <Icon
                    type="close-circle"
                    theme="twoTone"
                    twoToneColor={'#c5c5c5'}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
      {showPreview && (
        <div ref={showPreviewRef} onKeyDown={handleKeyDown} tabIndex={0}>
          <Lightbox
            medium={createImagePreview(attachedImages[currentImageIndex])}
            large={createImagePreview(attachedImages[currentImageIndex])}
            onClose={handleClosePreview}
            alt={attachedImages[currentImageIndex].name}
            onPrev={attachedImages.length > 1 && handlePrevPreview}
            onNext={attachedImages.length > 1 && handleNextPreview}
          />
        </div>
      )}
    </>
  );
};

export default memo(AttachedImages);
